import styles from './ErrorContent.module.scss';
import { ErrorModalContent } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onConfirm(): void;
};
export const ErrorContent = ({ onConfirm }: Props) => {
  const errorMessage = useSelector(selectModalsErrors).createPatientError;
  return (
    <ErrorModalContent
      title="Patient case is not created"
      subtitle={`The patient case is not created${errorMessage ? `. ${errorMessage}` : ' due to technical errors'}`}
      contentContainerClassname={styles.errorModalContentContainer}
      onConfirm={onConfirm}
    />
  );
};
